import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Search from "../../Search/Search";
import Title from "../../Title/Title";

type Student = {
  examNumber: string;
  name: string;
  father: string;
  mother: string;
  grade: number;
  gradeText: string;
  result: string;
  matched: boolean;
};

export default function Check_Marks_Matching() {
  const students: Student[] = [
    {
      examNumber: "0000",
      name: "الاحمد أحمد",
      father: "احمد",
      mother: "خلود",
      grade: 60,
      gradeText: "ستون",
      result: "ناجح",
      matched: true,
    },
  ];

  return (
    <>
      <Row>
        <Col>
          <Title title="فحص تطابق العلامات " />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم الطالب / اسم الطالب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className="  bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td>الفصل الدراسي</td>
                <td className="px-10"></td>
                <td>اسم المقرر </td>
                <td className="px-10"></td>
                <td className="px-10"></td>
                <td> رمز المقرر </td>
                <td className="px-10"></td>
                <td>
                  <button className=" bg-[#F6F8F9] p-2 rounded-2xl">
                    تصدير كملف اكسل
                  </button>
                </td>
              </tr>
            </thead>

            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td> الرقم الامتحاني </td>
                <td> اسم الطالب ونسبته</td>
                <td> الاب </td>
                <td> الام </td>
                <td> العلامة رقم </td>
                <td> العلامة كتابة </td>
                <td>النتيجة</td>
                <td>مطابق/غير مطابق</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              {students.map((student, index) => (
                <tr key={index} className="border-2 border-white">
                  <td>{student.examNumber}</td>
                  <td>{student.name}</td>
                  <td>{student.father}</td>
                  <td>{student.mother}</td>
                  <td>{student.grade}</td>
                  <td>{student.gradeText}</td>
                  <td>{student.result}</td>
                  <td>{student.matched ? "مطابق" : "غير مطابق"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
      <Row>
        <Col
          lg={11}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-4 "
        >
          <MainButton titlebtn="اعلان النتائج" className="w-[400px]" />
        </Col>
      </Row>
    </>
  );
}
